import { Page } from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";
import { AnimatedDots } from "../../../../components/AnimatedDots";
import React from "react";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { completeEurekaAuthIfPossible, EUREKA_CLIENT_ID } from "../../../../utilities/eureka";

export const EurekaOAuthCallbackScreen = () => {
  const { authenticate } = useAuthenticationProvider();
  const didRun = React.useRef(false);

  React.useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    (async () => {
      try {
        const { code, codeVerifier, redirectUri } =
          await completeEurekaAuthIfPossible();

        authenticate({
          eureka: {
            code,
            codeVerifier,
            redirectUri,
            clientId: EUREKA_CLIENT_ID,
          },
        })
          .then((result) => {
            console.log(result);
            // redirect to the root of the app after successful authentication
            window.location.href = "/";
          })
          .catch((err) => {
            console.log(err);
            // redirect to the root of the app even if there's an error (e.g. invalid token) to avoid leaving the user stuck on this screen
            window.location.href = "/login";
          });
      } catch (e) {
        console.log(e);
        // redirect to the root of the app even if there's an error (e.g. missing code_verifier) to avoid leaving the user stuck on this screen
        window.location.href = "/login";
      }
    })();
  }, []);

  return (
    <Page padding={0} fullWidth scrollable={false}>
      <View
        //@ts-ignore
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
        }}
      >
        <AnimatedDots
          //@ts-ignore
          style={{
            textAlign: "center",
          }}
          text="Please wait while we log you in."
        />
      </View>
    </Page>
  );
};
